import { CourseDef } from '../../../../types';
import L2079361 from './2079361';
import L2084296 from './2084296';
// import L5234457 from './5234457';
import L5234458 from './5234458';

export const padroesDeVelas: CourseDef = {
  courseTitle: 'PADRÕES DE VELAS',
  lessons: [L2079361, L2084296, 
    // L5234457,
    L5234458],
};

